import React from 'react';
import BeaconMetricSplineChart from 'src/components/BeaconV2Components/BeaconMetricSplineChart/BeaconMetricSplineChart';
import useKeywordSearchRequestBuilder from './useKeywordSearchRequestBuilder';
import AdvancedSearchRequestBuilder from 'src/components/BeaconV2Components/utils/AdvancedSearchRequestBuilder';

/**
 * Organic traffic spline chart for the keywords search page
 */
const KeywordSearchOrganicTrafficSpline = ({
  builderFunction
}: {
  builderFunction?: (
    additionalBuilder?: (builder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder
  ) => (requestBuilder: AdvancedSearchRequestBuilder) => AdvancedSearchRequestBuilder;
}) => {
  const keywordSearchRequestBuilder = useKeywordSearchRequestBuilder('traffic');
  const builderForRequest = builderFunction || keywordSearchRequestBuilder;

  return <BeaconMetricSplineChart indexName="traffic" fieldName="organicClicks" requestBuilder={builderForRequest()} />;
};

export default KeywordSearchOrganicTrafficSpline;
